export const usersMockData = [
  {
    id: 'PH34',
    name: 'Joy',
    userType: 'General Admin',
    status: 'Inhouse',
    startDate: '12/03/2025',
    endDate: '12/03/2025',
    invoiceDate: 'NA',
    dueDate: 'NA',
    paymentStatus: 'NA',
    paymentMethod: 'NA',
    organizations: [
      {
        id: '1',
        name: 'Acme Corporation',
        role: 'Admin',
        joinedDate: '12/03/2024',
        product: 'Process Monitoring',
        projectCount: 3
      }
    ],
    projects: [
      {
        name: 'Quality Assurance',
        role: 'Admin',
        owner: 'Donna May',
        isOwner: true
      },
      {
        name: 'Process Optimization',
        role: 'Admin',
        owner: 'Donna May',
        isOwner: true
      },
      {
        name: 'Resource Planning',
        role: 'User',
        owner: 'John Doe',
        isOwner: false
      },

    ]
  },
  {
    id: 'PH76',
    name: 'Daniel',
    userType: 'Developer',
    status: 'Inhouse',
    startDate: '12/03/2025',
    endDate: '12/03/2025',
    invoiceDate: 'NA',
    dueDate: 'NA',
    paymentStatus: 'NA',
    paymentMethod: 'NA',
    organizations: [
      {
        id: '1',
        name: 'Acme Corporation',
        role: 'Admin',
        joinedDate: '12/03/2024',
        product: 'Process Monitoring',
        projectCount: 6
      }
    ],
    projects: [
      {
        name: 'Quality Assurance',
        role: 'Admin',
        owner: 'Donna May',
        isOwner: true
      },
      {
        name: 'Process Optimization',
        role: 'Admin',
        owner: 'Donna May',
        isOwner: true
      },
      {
        name: 'Resource Planning',
        role: 'User',
        owner: 'John Doe',
        isOwner: false
      },
      {
        name: 'Cost Analysis',
        role: 'Admin',
        owner: 'Donna May',
        isOwner: true
      },
      {
        name: 'Performance Metrics',
        role: 'User',
        owner: 'Jane Smith',
        isOwner: false
      },
      {
        name: 'Workflow Automation',
        role: 'Admin',
        owner: 'Donna May',
        isOwner: true
      }
    ]
  },
  {
    id: 'PH45',
    name: 'John',
    userType: 'Designer',
    status: 'Inhouse',
    startDate: '12/03/2025',
    endDate: '12/03/2025',
    invoiceDate: '12/03/2025',
    dueDate: 'NA',
    paymentStatus: 'NA',
    paymentMethod: 'NA',
    organizations: [
      {
        id: '1',
        name: 'Acme Corporation',
        role: 'Admin',
        joinedDate: '12/03/2024',
        product: 'Process Monitoring',
        projectCount: 2
      }
    ],
    projects: [
      {
        name: 'Quality Assurance',
        role: 'Admin',
        owner: 'Donna May',
        isOwner: true
      },

      {
        name: 'Resource Planning',
        role: 'User',
        owner: 'John Doe',
        isOwner: false
      },

    ]
  },
  {
    id: 'PH54',
    name: 'Ann',
    userType: 'Subscriber',
    status: 'Expired',
    startDate: '12/03/2025',
    endDate: '12/03/2025',
    invoiceDate: '12/03/2025',
    dueDate: '04/05/2024',
    paymentStatus: 'Pending',
    paymentMethod: 'Credit card',
    organizations: [
      {
        id: '1',
        name: 'Acme Corporation',
        role: 'Admin',
        joinedDate: '12/03/2024',
        product: 'Operational Excellence',
        projectCount: 3
      }
    ],
    projects: [
      {
        name: 'Quality Assurance',
        role: 'Admin',
        owner: 'Donna May',
        isOwner: true
      },

      {
        name: 'Resource Planning',
        role: 'User',
        owner: 'John Doe',
        isOwner: false
      },

      {
        name: 'Performance Metrics',
        role: 'User',
        owner: 'Jane Smith',
        isOwner: false
      }
    ]
  },
  {
    id: 'PH66',
    name: 'Dany',
    userType: 'Subscriber',
    status: 'Active',
    startDate: '12/03/2025',
    endDate: '12/03/2025',
    invoiceDate: '12/03/2025',
    dueDate: '02/06/2024',
    paymentStatus: 'Paid',
    paymentMethod: 'Credit card',
    organizations: [
      {
        id: '1',
        name: 'Acme Corporation',
        role: 'Admin',
        joinedDate: '12/03/2024',
        product: 'Process Monitoring',
        projectCount: 3
      }
    ],
    projects: [
      {
        name: 'Quality Assurance',
        role: 'Admin',
        owner: 'Donna May',
        isOwner: true
      },
      {
        name: 'Process Optimization',
        role: 'Admin',
        owner: 'Donna May',
        isOwner: true
      },
      {
        name: 'Resource Planning',
        role: 'User',
        owner: 'John Doe',
        isOwner: false
      },

    ]
  },
  {
    id: 'PH43',
    name: 'Joy',
    userType: 'Trial',
    status: 'Active',
    startDate: '12/03/2025',
    endDate: '12/03/2025',
    invoiceDate: '12/03/2025',
    dueDate: '19/01/2025',
    paymentStatus: 'Paid',
    paymentMethod: 'Credit card',
    organizations: [
      {
        id: '1',
        name: 'Acme Corporation',
        role: 'Admin',
        joinedDate: '12/03/2024',
        product: 'Process Monitoring',
        projectCount: 1
      }
    ],
    projects: [
      {
        name: 'Quality Assurance',
        role: 'Admin',
        owner: 'Donna May',
        isOwner: true
      },

    ]
  }
];



export const demoOrganizationsMockData = [
  {
    id: 1,
    name: "Acme Corporation",
    desc: "This is a description for Acme Corporation",
    subscriberCount: 15,
    createdBy: "John Doe",
    createdDate: "12/03/2024",
    product: "Process Monitoring",
    projectCount: 7,
    users: [
      {
        id: 'PH321',
        name: 'Donna May',
        subscriptionType: 'Basic',
        product: 'Operational excellence',
        projectCount: 4,
        organization: 'Acme Corporation',
        phoneNumber: '+1234567890',
        email: 'donna@example.com',
        role: 'admin',
        projects: [
          {
            name: 'Project1',
            role: 'Admin',
            owner: 'Donna May',
            isOwner: true
          },
          {
            name: 'Project2',
            role: 'User',
            owner: 'John Doe',
            isOwner: false
          },
          {
            name: 'Project3',
            role: 'Admin',
            owner: 'Donna May',
            isOwner: true
          },
          {
            name: 'Project4',
            role: 'User',
            owner: 'Jane Smith',
            isOwner: false
          }
        ]
      },
      {
        id: 'PH322',
        name: 'Stephen Ogden',
        subscriptionType: 'Standard',
        product: 'Operational Excellence',
        projectCount: 3,
        projects: ['Project1', 'Project2'],
        organization: 'Acme Corporation',
        phoneNumber: '+1234567891',
        email: 'stephen@example.com',
        role: 'user'
      },
      {
        id: 'PH323',
        name: 'John Doe',
        subscriptionType: 'Basic',
        product: 'Operational excellence',
        projectCount: 4,
        projects: ['Project1', 'Project2', 'Project3', 'Project4'],
        organization: 'Acme Corporation',

        phoneNumber: '+1234567892',
        email: 'john@example.com',
        role: 'user'
      },
      {
        id: 'PH324',
        name: 'Jane Doe',
        subscriptionType: 'Basic',
        product: 'Operational excellence',
        projectCount: 4,
        projects: ['Project1', 'Project2', 'Project3', 'Project4'],
        organization: 'Acme Corporation',

        phoneNumber: '+1234567892',
        email: 'jane@example.com',
        role: 'user'
      },
      {
        id: 'PH325',
        name: 'John Doe',
        subscriptionType: 'Basic',
        product: 'Operational excellence',
        projectCount: 4,
        projects: ['Project1', 'Project2', 'Project3', 'Project4'],
        organization: 'Acme Corporation',

        phoneNumber: '+1234567892',
        email: 'john@example.com',
        role: 'user'
      },

      {
        id: 'PH326',
        name: 'Donna May',
        subscriptionType: 'Basic',
        product: 'Operational excellence',
        projectCount: 4,
        projects: ['Project1', 'Project2', 'Project3', 'Project4'],
        organization: 'Acme Corporation',

        phoneNumber: '+1234567890',
        email: 'donna@example.com',
        role: 'admin'
      },
      {
        id: 'PH327',
        name: 'Stephen Ogden',
        subscriptionType: 'Standard',
        product: 'Operational Excellence',
        projectCount: 3,
        projects: ['Project1', 'Project2'],

        organization: 'Acme Corporation',
        phoneNumber: '+1234567891',
        email: 'stephen@example.com',
        role: 'user'
      },
      {
        id: 'PH328',
        name: 'John Doe',
        subscriptionType: 'Basic',
        product: 'Operational excellence',
        projectCount: 4,
        projects: ['Project1', 'Project2', 'Project3', 'Project4'],

        organization: 'Acme Corporation',
        phoneNumber: '+1234567892',
        email: 'john@example.com',
        role: 'user'
      },
      {
        id: 'PH329',
        name: 'Jane Doe',
        subscriptionType: 'Basic',
        product: 'Operational excellence',
        projectCount: 4,
        projects: ['Project1', 'Project2', 'Project3', 'Project4'],

        organization: 'Acme Corporation',
        phoneNumber: '+1234567892',
        email: 'jane@example.com',
        role: 'user'
      },
      {
        id: 'PH330',
        name: 'John Doe',
        subscriptionType: 'Basic',
        product: 'Operational excellence',
        projectCount: 4,
        projects: ['Project1', 'Project2', 'Project3', 'Project4'],

        organization: 'Acme Corporation',
        phoneNumber: '+1234567892',
        email: 'john@example.com',
        role: 'user'
      },

    ],
  },
  {
    id: 2,
    name: "TechStart Solutions",
    desc: "This is a description for TechStart Solutions",
    subscriberCount: 2,
    createdBy: "Jane Smith",
    createdDate: "15/03/2024",
    product: "Process Monitoring",
    projectCount: 4,
    users: [
      {
        id: 'PH321',
        name: 'Donna May',
        subscriptionType: 'Basic',
        product: 'Operational excellence',
        projectCount: 4,
        organization: 'Acme Corporation',
        phoneNumber: '+1234567890',
        email: 'donna@example.com',
        role: 'admin',
        projects: [
          {
            name: 'Project1',
            role: 'Admin',
            owner: 'Donna May',
            isOwner: true
          },
          {
            name: 'Project2',
            role: 'User',
            owner: 'John Doe',
            isOwner: false
          },
          {
            name: 'Project3',
            role: 'Admin',
            owner: 'Donna May',
            isOwner: true
          },
          {
            name: 'Project4',
            role: 'User',
            owner: 'Jane Smith',
            isOwner: false
          }
        ]
      },
      {
        id: 'PH323',
        name: 'Stephen Ogden',
        subscriptionType: 'Standard',
        product: 'Operational Excellence',
        projectCount: 3,
        projects: ['Project1', 'Project2'],
        organization: 'Acme Corporation',
        phoneNumber: '+1234567891',
        email: 'stephen@example.com',
        role: 'user'
      },
    ],
  },
  {
    id: 3,
    name: "Global Innovations Ltd",
    desc: "This is a description for Global Innovations Ltd",
    subscriberCount: 4,
    createdBy: "Mike Johnson",
    createdDate: "18/03/2024",
    product: "Process Monitoring",
    projectCount: 3,
    users: [
      {
        id: 'PH321',
        name: 'Donna May',
        subscriptionType: 'Basic',
        product: 'Operational excellence',
        projectCount: 4,
        organization: 'Acme Corporation',
        phoneNumber: '+1234567890',
        email: 'donna@example.com',
        role: 'admin',
        projects: [
          {
            name: 'Project1',
            role: 'Admin',
            owner: 'Donna May',
            isOwner: true
          },
          {
            name: 'Project2',
            role: 'User',
            owner: 'John Doe',
            isOwner: false
          },
          {
            name: 'Project3',
            role: 'Admin',
            owner: 'Donna May',
            isOwner: true
          },
          {
            name: 'Project4',
            role: 'User',
            owner: 'Jane Smith',
            isOwner: false
          }
        ]
      },
      {
        id: 'PH323',
        name: 'Stephen Ogden',
        subscriptionType: 'Standard',
        product: 'Operational Excellence',
        projectCount: 3,
        projects: ['Project1', 'Project2'],
        organization: 'Acme Corporation',
        phoneNumber: '+1234567891',
        email: 'stephen@example.com',
        role: 'user'
      },
      {
        id: 'PH321',
        name: 'Donna May',
        subscriptionType: 'Basic',
        product: 'Operational excellence',
        projectCount: 4,
        organization: 'Acme Corporation',
        phoneNumber: '+1234567890',
        email: 'donna@example.com',
        role: 'admin',
        projects: [
          {
            name: 'Project1',
            role: 'Admin',
            owner: 'Donna May',
            isOwner: true
          },
          {
            name: 'Project2',
            role: 'User',
            owner: 'John Doe',
            isOwner: false
          },
          {
            name: 'Project3',
            role: 'Admin',
            owner: 'Donna May',
            isOwner: true
          },
          {
            name: 'Project4',
            role: 'User',
            owner: 'Jane Smith',
            isOwner: false
          }
        ]
      },
      {
        id: 'PH323',
        name: 'Stephen Ogden',
        subscriptionType: 'Standard',
        product: 'Operational Excellence',
        projectCount: 3,
        projects: ['Project1', 'Project2'],
        organization: 'Acme Corporation',
        phoneNumber: '+1234567891',
        email: 'stephen@example.com',
        role: 'user'
      },
    ],
  },
];

export const activityLogsMockData = [
  {
    timestamp: '2024-03-20 14:30:45',
    user: 'John Doe',
    userType: 'Admin',
    activity: 'Data Delete',
    description: 'Here is the description for User logged in successfully',
    status: 'Success',
    organization: 'Acme Corporation',
  },
  {
    timestamp: '2024-03-25 14:25:30',
    user: 'Jane Smith',
    userType: 'User',
    activity: 'Settings Update',
    description: 'Here is the description for Created new project "Analytics Dashboard"',
    status: 'Success',
    organization: 'Acme Corporation',
  },
  {
    timestamp: '2025-03-20 14:20:15',
    user: 'Mike Johnson',
    userType: 'Manager',
    activity: 'Permission Change',
    description: 'Here is the description for Updated user permissions',
    status: 'Failed',
    organization: 'Umbrella Corporation',
  },
  {
    timestamp: '2024-01-20 14:15:00',
    user: 'Sarah Wilson',
    userType: 'User',
    activity: 'Role Update',
    description: 'Here is the description for Deleted project "Old Dashboard"',
    status: 'Success',
    organization: 'Initech',
  },
  // Add more activity logs...
];

export const emailLogsMockData = [
  {
    date: '2024-03-20',
    emailType: 'Welcome Email',
    status: 'Sent',
    sendTo: 'john@example.com',
    organization: 'Acme Corporation',
  },
  {
    date: '2024-03-25',
    emailType: 'Password Reset',
    status: 'Failed',
    sendTo: 'jane@example.com',
    organization: 'Acme Corp',
  },
  {
    date: '2024-04-20',
    emailType: 'Verification',
    status: 'Sent',
    sendTo: 'mike@example.com',
    organization: 'Initech',
  },
  {
    date: '2025-03-20',
    emailType: 'Newsletter',
    status: 'Pending',
    sendTo: 'sarah@example.com',
    organization: 'Acme Corporation',
  },
  // Add more email logs...
];

export const auditTrailsMockData = [
  {
    date: '2025-03-20',
    user: 'John Doe',
    userType: 'Admin',
    change: 'Role Update',
    description: 'Here is the description for Changed user role from User to Admin.',
    organization: 'Acme Corporation',
  },
  {
    date: '2024-04-20',
    user: 'Jane Smith',
    userType: 'Manager',
    change: 'Permission Change',
    description: 'Here is the description for Added project management permissions',
    organization: 'Acme Corporation',
  },
  {
    date: '2024-03-20',
    user: 'Mike Johnson',
    userType: 'User',
    change: 'Settings Update',
    description: 'Here is the description for Updated organization settings',
    organization: 'Globex Inc',
  },
  {
    date: '2024-02-25',
    user: 'Sarah Wilson',
    userType: 'Guest',
    change: 'Data Delete',
    description: 'Here is the description for Removed old project data',
    organization: 'Acme Corporation',
  },
  // Add more audit trails...
];

export interface Ticket {
  id: string;
  status: string;
  customer: string;
  name: string;
  description: string;
  addedOn: string;
  organization: string;

  assignedTo: string;
  lastUpdated: string;
  email?: string;
  priority?: string;
  escalationDetails?: {
    isEscalated: boolean;
    reason?: string;
    date?: string;
  };
  assignees?: { id: string; label: string }[];
  attachments?: File[];
}


export const ticketsData: Ticket[] = [
  {
    id: '#0001',
    status: 'Open',
    customer: 'John Doe',
    email: 'johndoe@gmail.com',
    name: 'Lorem ipsum',
    description: 'Here is the description for Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    addedOn: '5/02/2024',
    assignedTo: 'john_smith',
    lastUpdated: '12/03/2025',
    priority: 'High',
    organization: 'Acme Corporation',
    escalationDetails: {
      isEscalated: true,
      date: '5/02/2024',
      reason: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
    },
    assignees: [
      { id: '', label: 'Select' },
      { id: 'john_smith', label: 'John Smith' },
      { id: 'sarah_parker', label: 'Sarah Parker' },
      { id: 'mike_johnson', label: 'Mike Johnson' },
      { id: 'emily_brown', label: 'Emily Brown' },
      { id: 'david_wilson', label: 'David Wilson' },
      { id: 'unassigned', label: 'Unassigned' },
    ],
    attachments: [
      new File([""], "document1.pdf", { type: "application/pdf" }),
      new File([""], "image1.jpg", { type: "image/jpeg" }),
      new File([""], "spreadsheet1.xlsx", { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
    ]
  },
  {
    id: '#0123',
    status: 'Unassigned',
    customer: 'John Doe',
    name: 'Lorem ipsum',
    description: 'Here is the description for Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore..',
    addedOn: '12/06/2024',
    assignedTo: 'unassigned',
    lastUpdated: '12/03/2025',
    organization: 'Initech',
    assignees: [
      { id: '', label: 'Select' },
      { id: 'john_smith', label: 'John Smith' },
      { id: 'sarah_parker', label: 'Sarah Parker' },
      { id: 'mike_johnson', label: 'Mike Johnson' },
      { id: 'emily_brown', label: 'Emily Brown' },
      { id: 'david_wilson', label: 'David Wilson' },
      { id: 'unassigned', label: 'Unassigned' }
    ],
  },
  {
    id: '#0003',
    status: 'Unassigned',
    customer: 'Donna May',
    name: 'Lorem ipsum',
    description: 'Here is the description for Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore..',
    addedOn: '12/03/2025',
    assignedTo: 'unassignedr',
    lastUpdated: '12/03/2025',
    organization: 'Initech',
    assignees: [
      { id: '', label: 'Select' },
      { id: 'john_smith', label: 'John Smith' },
      { id: 'sarah_parker', label: 'Sarah Parker' },
      { id: 'mike_johnson', label: 'Mike Johnson' },
      { id: 'emily_brown', label: 'Emily Brown' },
      { id: 'david_wilson', label: 'David Wilson' },
      { id: 'unassigned', label: 'Unassigned' }
    ],
  },
  {
    id: '#0004',
    status: 'Unassigned',
    customer: 'James Vance',
    name: 'Lorem ipsum',
    description: 'Here is the description for Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore..',
    addedOn: '04/05/2024',
    assignedTo: 'unassigned',
    lastUpdated: '12/03/2025',
    organization: 'Acme Corporation',
    assignees: [
      { id: '', label: 'Select' },
      { id: 'john_smith', label: 'John Smith' },
      { id: 'sarah_parker', label: 'Sarah Parker' },
      { id: 'mike_johnson', label: 'Mike Johnson' },
      { id: 'emily_brown', label: 'Emily Brown' },
      { id: 'david_wilson', label: 'David Wilson' },
      { id: 'unassigned', label: 'Unassigned' }
    ],
  },
  {
    id: '#0005',
    status: 'Unassigned',
    customer: 'Stephen Ogden',
    name: 'Lorem ipsum',
    description: 'Here is the description for Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore..',
    addedOn: '12/03/2025',
    assignedTo: 'unassigned',
    lastUpdated: '12/03/2025',
    organization: 'Acme Corporation',
    assignees: [
      { id: '', label: 'Select' },
      { id: 'john_smith', label: 'John Smith' },
      { id: 'sarah_parker', label: 'Sarah Parker' },
      { id: 'mike_johnson', label: 'Mike Johnson' },
      { id: 'emily_brown', label: 'Emily Brown' },
      { id: 'david_wilson', label: 'David Wilson' },
      { id: 'unassigned', label: 'Unassigned' }
    ],
  },
  {
    id: '#0090',
    status: 'Unassigned',
    customer: 'Stewart Skinner',
    name: 'Lorem ipsum',
    description: 'Here is the description for Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore..',
    addedOn: '02/06/2024',
    assignedTo: 'unassigned',
    lastUpdated: '12/03/2025',
    organization: 'Globex Inc',
    assignees: [
      { id: '', label: 'Select' },
      { id: 'john_smith', label: 'John Smith' },
      { id: 'sarah_parker', label: 'Sarah Parker' },
      { id: 'mike_johnson', label: 'Mike Johnson' },
      { id: 'emily_brown', label: 'Emily Brown' },
      { id: 'david_wilson', label: 'David Wilson' },
      { id: 'unassigned', label: 'Unassigned' }
    ],
  },
  {
    id: '#0012',
    status: 'Unassigned',
    customer: 'Mark Francis',
    name: 'Lorem ipsum',
    description: 'Here is the description for Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore..',
    addedOn: '3/01/2025',
    assignedTo: 'unassigned',
    lastUpdated: '12/03/2025',
    organization: 'Umbrella Corporation',
    assignees: [
      { id: '', label: 'Select' },
      { id: 'john_smith', label: 'John Smith' },
      { id: 'sarah_parker', label: 'Sarah Parker' },
      { id: 'mike_johnson', label: 'Mike Johnson' },
      { id: 'emily_brown', label: 'Emily Brown' },
      { id: 'david_wilson', label: 'David Wilson' },
      { id: 'unassigned', label: 'Unassigned' }
    ],
  },
  {
    id: '#0002',
    status: 'Unassigned',
    customer: 'Jane Smith',
    email: 'janesmith@gmail.com',
    name: 'Technical Issue',
    description: 'Here is the description for Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    addedOn: '6/02/2024',
    assignedTo: 'unassigned',
    lastUpdated: '13/03/2025',
    priority: 'Medium',
    escalationDetails: {
      isEscalated: false
    },
    assignees: [
      { id: '', label: 'Select' },
      { id: 'john_smith', label: 'John Smith' },
      { id: 'sarah_parker', label: 'Sarah Parker' },
      { id: 'mike_johnson', label: 'Mike Johnson' },
      { id: 'emily_brown', label: 'Emily Brown' },
      { id: 'david_wilson', label: 'David Wilson' },
      { id: 'unassigned', label: 'Unassigned' }
    ],
    attachments: [
      new File([""], "screenshot.png", { type: "image/png" })
    ],
    organization: 'Umbrella Corporation',
  }
];

export const roles = [
  {
    id: '1',
    name: 'Super Admin',
    description: 'Here is the description for Manages admins, billing admins, support agents, developers, and...',
    isActive: true,
    permissions: ['all'],
    createdAt: '2024-02-01'
  },
  {
    id: '2',
    name: 'Billing Admin',
    description: 'Here is the description for Handles payment processing, subscription management, and billing issues...',
    isActive: true,
    permissions: ['billing.manage', 'billing.view'],
    createdAt: '2024-02-01'
  },
  {
    id: '3',
    name: 'Customer',
    description: 'Here is the description for Manages their accounts and interacts with Support Agents for help...',
    isActive: true,
    permissions: ['account.manage', 'tickets.create'],
    createdAt: '2024-02-01'
  },
  {
    id: '4',
    name: 'Support Agent',
    description: 'Here is the description for Provides customer support by managing tickets and interacting with...',
    isActive: true,
    permissions: ['tickets.manage', 'tickets.respond'],
    createdAt: '2024-02-01'
  },
  {
    id: '5',
    name: 'Developer',
    description: 'Here is the description for Focuses on API integration and platform customization...',
    isActive: true,
    permissions: ['api.access', 'api.manage'],
    createdAt: '2024-02-01'
  }
];

export const plans = [
  {
    id: '1',
    name: 'Trial Plan',
    description: 'Here is the description for Trial Plan',
    isActive: true,
    permissions: ['all'],
    createdAt: '2024-02-01'
  },
  {
    id: '2',
    name: 'Basic Plan',
    description: 'Here is the description for Basic Plan',
    isActive: true,
    permissions: ['billing.manage', 'billing.view'],
    createdAt: '2024-02-01'
  },
  {
    id: '3',
    name: 'Pro Plan',
    description: 'Here is the description for Pro Plan',
    isActive: true,
    permissions: ['account.manage', 'tickets.create'],
    createdAt: '2024-02-01'
  },
  {
    id: '4',
    name: 'Enterprise Plan',
    description: 'Here is the description for Enterprise Plan',
    isActive: true,
    permissions: ['tickets.manage', 'tickets.respond'],
    createdAt: '2024-02-01'
  },
];



export interface Permission {
  id: string;
  name: string;
  isEnabled: boolean;
  functionalities: {
    id: string;
    name: string;
    description: string;
    isEnabled: boolean;
  }[];
}
export const permissions: Permission[] = [
  {
    id: '1',
    name: 'User Management',
    isEnabled: true,
    functionalities: [
      { id: '1', name: 'View users', description: 'Here is the description for View users, Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eveniet quidem nulla, distinctio totam reiciendis vitae. Repellat, illum voluptates deserunt veniam, laborum atque sed similique consequuntur minima asperiores fuga aut recusandae', isEnabled: true },
      { id: '2', name: 'Create users', description: 'Here is the description for Create users, Here is the description for View users, Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eveniet quidem nulla, distinctio totam reiciendis vitae. Repellat, illum voluptates deserunt veniam, laborum atque sed similique consequuntur minima asperiores fuga aut recusandae', isEnabled: true },
      { id: '3', name: 'Edit users', description: 'Here is the description for Edit users, Here is the description for View users, Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eveniet quidem nulla, distinctio totam reiciendis vitae. Repellat, illum voluptates deserunt veniam, laborum atque sed similique consequuntur minima asperiores fuga aut recusandae', isEnabled: true },
      { id: '4', name: 'Delete users', description: 'Here is the description for Delete users, Here is the description for View users, Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eveniet quidem nulla, distinctio totam reiciendis vitae. Repellat, illum voluptates deserunt veniam, laborum atque sed similique consequuntur minima asperiores fuga aut recusandae', isEnabled: true },
    ]
  },
  {
    id: '2',
    name: 'Plan',
    isEnabled: true,
    functionalities: [
      { id: '5', name: 'View Plan', description: 'Here is the description for View Plan, Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eveniet quidem nulla, distinctio totam reiciendis vitae. Repellat, illum voluptates deserunt veniam, laborum atque sed similique consequuntur minima asperiores fuga aut recusandae', isEnabled: true },
      { id: '6', name: 'Create Plan', description: 'Here is the description for Create Plan, Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eveniet quidem nulla, distinctio totam reiciendis vitae. Repellat, illum voluptates deserunt veniam, laborum atque sed similique consequuntur minima asperiores fuga aut recusandae', isEnabled: false },
      { id: '7', name: 'Edit Plan', description: 'Here is the description for Edit Plan, Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eveniet quidem nulla, distinctio totam reiciendis vitae. Repellat, illum voluptates deserunt veniam, laborum atque sed similique consequuntur minima asperiores fuga aut recusandae', isEnabled: false },
      { id: '8', name: 'Delete Plan', description: 'Here is the description for Delete Plan, Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eveniet quidem nulla, distinctio totam reiciendis vitae. Repellat, illum voluptates deserunt veniam, laborum atque sed similique consequuntur minima asperiores fuga aut recusandae', isEnabled: false },
      { id: '9', name: 'Archive Plan', description: 'Here is the description for Archive Plan, Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eveniet quidem nulla, distinctio totam reiciendis vitae. Repellat, illum voluptates deserunt veniam, laborum atque sed similique consequuntur minima asperiores fuga aut recusandae', isEnabled: false },
      { id: '10', name: 'Cancel Plan', description: 'Here is the description for Cancel Plan, Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eveniet quidem nulla, distinctio totam reiciendis vitae. Repellat, illum voluptates deserunt veniam, laborum atque sed similique consequuntur minima asperiores fuga aut recusandae', isEnabled: false },
    ]
  },
  {
    id: '3',
    name: 'Subscription',
    isEnabled: true,
    functionalities: [
      { id: '11', name: 'View Subscription', description: 'Here is the description for View Subscription, Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eveniet quidem nulla, distinctio totam reiciendis vitae. Repellat, illum voluptates deserunt veniam, laborum atque sed similique consequuntur minima asperiores fuga aut recusandae', isEnabled: true },
      { id: '12', name: 'Create Subscription', description: 'Here is the description for Create Subscription, Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eveniet quidem nulla, distinctio totam reiciendis vitae. Repellat, illum voluptates deserunt veniam, laborum atque sed similique consequuntur minima asperiores fuga aut recusandae', isEnabled: false },
      { id: '13', name: 'Edit Subscription', description: 'Here is the description for Edit Subscription, Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eveniet quidem nulla, distinctio totam reiciendis vitae. Repellat, illum voluptates deserunt veniam, laborum atque sed similique consequuntur minima asperiores fuga aut recusandae', isEnabled: false },
      { id: '14', name: 'Cancel Subscription', description: 'Here is the description for Cancel Subscription, Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eveniet quidem nulla, distinctio totam reiciendis vitae. Repellat, illum voluptates deserunt veniam, laborum atque sed similique consequuntur minima asperiores fuga aut recusandae', isEnabled: false },
    ]
  },
  {
    id: '4',
    name: 'Billing',
    isEnabled: true,
    functionalities: [
      { id: '15', name: 'Handle payments', description: 'Here is the description for Handle payments, Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eveniet quidem nulla, distinctio totam reiciendis vitae. Repellat, illum voluptates deserunt veniam, laborum atque sed similique consequuntur minima asperiores fuga aut recusandae', isEnabled: true },
      { id: '16', name: 'Manage billing', description: 'Here is the description for Manage billing, Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eveniet quidem nulla, distinctio totam reiciendis vitae. Repellat, illum voluptates deserunt veniam, laborum atque sed similique consequuntur minima asperiores fuga aut recusandae', isEnabled: true },
      { id: '17', name: 'Retry failed payments', description: 'Here is the description for Retry failed payments, Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eveniet quidem nulla, distinctio totam reiciendis vitae. Repellat, illum voluptates deserunt veniam, laborum atque sed similique consequuntur minima asperiores fuga aut recusandae', isEnabled: true },
      { id: '18', name: 'View Billing History', description: 'Here is the description for View Billing History, Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eveniet quidem nulla, distinctio totam reiciendis vitae. Repellat, illum voluptates deserunt veniam, laborum atque sed similique consequuntur minima asperiores fuga aut recusandae', isEnabled: true },
      { id: '19', name: 'Manage Upgrades/Downgrades/Cancellations', description: 'Here is the description for Manage Upgrades/Downgrades/Cancellations, Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eveniet quidem nulla, distinctio totam reiciendis vitae. Repellat, illum voluptates deserunt veniam, laborum atque sed similique consequuntur minima asperiores fuga aut recusandae', isEnabled: true },
      { id: '20', name: 'Manage refund requests', description: 'Here is the description for Manage refund requests, Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eveniet quidem nulla, distinctio totam reiciendis vitae. Repellat, illum voluptates deserunt veniam, laborum atque sed similique consequuntur minima asperiores fuga aut recusandae', isEnabled: true },
      { id: '21', name: 'Approve refund requests', description: 'Here is the description for Approve refund requests, Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eveniet quidem nulla, distinctio totam reiciendis vitae. Repellat, illum voluptates deserunt veniam, laborum atque sed similique consequuntur minima asperiores fuga aut recusandae', isEnabled: true },
      { id: '22', name: 'Adjust accounts with credits', description: 'Here is the description for Adjust accounts with credits, Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eveniet quidem nulla, distinctio totam reiciendis vitae. Repellat, illum voluptates deserunt veniam, laborum atque sed similique consequuntur minima asperiores fuga aut recusandae', isEnabled: true },
    ]
  },
  {
    id: '5',
    name: 'Support Management',
    isEnabled: true,
    functionalities: [
      { id: '23', name: 'Create support ticket', description: 'Here is the description for Create support ticket', isEnabled: true },
      { id: '24', name: 'View support ticket', description: 'Here is the description for View support ticket', isEnabled: true },
      { id: '25', name: 'Manage support ticket', description: 'Here is the description for Manage support ticket', isEnabled: true },
      { id: '26', name: 'Access Knowledge Base', description: 'Here is the description for Access Knowledge Base', isEnabled: true },
      { id: '27', name: 'Update Knowledge Base', description: 'Here is the description for Update Knowledge Base', isEnabled: true },
      { id: '28', name: 'Manage refund requests', description: 'Here is the description for Manage refund requests', isEnabled: true },
      { id: '29', name: 'Approve refund requests', description: 'Here is the description for Approve refund requests', isEnabled: true },
      { id: '30', name: 'Adjust accounts with credits', description: 'Here is the description for Adjust accounts with credits', isEnabled: true },
    ]
  },
  {
    id: '6',
    name: 'Dashboard',
    isEnabled: true,
    functionalities: [
      { id: '31', name: 'View', description: 'Here is the description for View', isEnabled: true },
    ]
  },
  {
    id: '7',
    name: 'System settings',
    isEnabled: true,
    functionalities: [
      { id: '32', name: 'Manage integrations', description: 'Here is the description for Manage integrations', isEnabled: true },
      { id: '33', name: 'API Access', description: 'Here is the description for API Access', isEnabled: true },
      { id: '34', name: 'Access to API documentation', description: 'Here is the description for Access to API documentation', isEnabled: true },
    ]
  },
  {
    id: '8',
    name: 'Notification',
    isEnabled: true,
    functionalities: [
      { id: '35', name: 'Users upgrade to higher plans or downgrade', description: 'Here is the description for Users upgrade to higher plans or downgrade', isEnabled: true },
      { id: '36', name: "User's subscription is about to expire", description: "User's subscription is about to expire", isEnabled: true },
      { id: '37', name: 'System health, performance issues, or security threats', description: 'Here is the description for System health, performance issues, or security threats', isEnabled: true },
      { id: '38', name: 'For unusual activity in the platform', description: 'Here is the description for For unusual activity in the platform', isEnabled: true },
      { id: '39', name: 'Send payment follow-up messages to customers', description: 'Here is the description for Send payment follow-up messages to customers', isEnabled: true },
      { id: '40', name: 'For failed payment attempts', description: 'Here is the description for For failed payment attempts', isEnabled: true },
      { id: '41', name: 'When the trial period is about to end and recommend', description: 'Here is the description for When the trial period is about to end and recommend', isEnabled: true },
      { id: '42', name: 'Refund approvals, payment retries, and subscription downgrades', description: 'Here is the description for Refund approvals, payment retries, and subscription downgrades', isEnabled: true },
    ]
  },
  {
    id: '9',
    name: 'Security',
    isEnabled: true,
    functionalities: [
      { id: '43', name: 'Setup and enforce security measures', description: 'Here is the description for Setup and enforce security measures', isEnabled: true },
      { id: '44', name: 'Access and review logs', description: 'Here is the description for Access and review logs', isEnabled: true },
    ]
  }
];


export interface MenuItem {
  id: string;
  label: string;
  subItems?: MenuItem[];
}

export interface AssetContent {
  id: string;
  title: string;
  desc: string;
}


export const menuItems: MenuItem[] = [
  {
    id: 'getting-started',
    label: 'Getting Started',
    subItems: [
      { id: 'controls-overview', label: 'Controls Overview' },
      { id: 'notes-overview', label: 'Notes Overview' },
      { id: 'widgets-overview', label: 'Widgets Overview' },
      { id: 'editing-mode', label: 'Editing Mode' }
    ]
  },
];

export interface GuideContent {
  title: string;
  videoUrl: string;
  thumbnail?: string;
  description: string;
}

export interface ConnectionProfile {
  id: string;
  title: string;
  status: string;
}


export const guideContent: Record<string, GuideContent> = {
  'controls-overview': {
    title: 'Controls Overview',
    videoUrl: 'https://drive.google.com/file/d/1XP08RMsAlFL6QUfzOyAcJPAbhkHE7lR_/view?usp=drive_link',
    description: `Learn the basic controls of ProcessHub and how to navigate the environment efficiently.

In this video, we cover the following essential controls:
To move, use the WASD keys or the arrow keys. Hold Shift to sprint. To cycle between camera views, press F or click the icon near the minimap. In drone view, use the same movement keys, E to ascend, and Q to descend.
For the navigation camera, use the same movement keys, hold the middle mouse button to reposition the view, and hold the right mouse button to rotate around the central marker.
To interact with objects, left-click for primary actions, such as opening widgets, and right-click for secondary actions, such as opening widget configuration windows.`,
  },
  'notes-overview': {
    title: 'Notes Overview',
    videoUrl: 'https://drive.google.com/file/d/153Lfoecqf76lJ6G6FWhX_dDTbhU9g7ec/view?usp=drive_link',
    description: `Learn how to create and manage notes in Process Hub.

To create a note, press Escape to enable the cursor. Click the note icon in the top-left menu or press the N key on your keyboard. Enter a title and write your note in the designated field.
If needed, attach .PDF, .XLSX, or .XLS files using the file attachment option. When you're done, click the Create button at the bottom of the pop-up window.

Your note will be saved to the server, making it accessible to other users. Attached files can also be viewed and downloaded by others.`,
  },
  'widgets-overview': {
    title: 'Widgets Overview',
    videoUrl: 'https://drive.google.com/file/d/1wLxwD_YcVrnRxihCT8gOd7mxn35QNBW5/view?usp=drive_link',
    description: `This tutorial covers creating and managing widgets in Process Hub. 

Enter Editing Mode by clicking the gear icon in the top-left menu, then open the Widget Tab. Click the Plus icon to create a widget, adjust its position with gizmos, and enter a name, description, and unit. If creating a child widget, select the equipment and assign tags.

To display tag information, click the Plus icon in the Actions column. Arrange tags, add text items, and enable constant widget visibility if needed. 

Interact with widgets by left-clicking to open them. View assigned tags, pin values, set alarms, create tickets, and analyze data with graphs. Documents can be attached in the Documents tab.`,
  },
  'editing-mode': {
    title: 'Editing Mode',
    videoUrl: 'https://drive.google.com/file/d/1JKNdEV-1AVsxxS3Ic1WURYaT1V_tgIFh/view?usp=drive_link',
    description: `This tutorial covers the editing mode in Process Hub, where you can build and manage scenes. 
Enter Editing Mode by clicking the gear icon in the top-left menu and access the Object Library. 

Objects snap to a grid by default, with adjustable settings for visibility and snapping.

To place objects, select one from the library, position it, and click to place. Use platforms for grouping or the resizable hangar for a dedicated space. Rotate objects with Q and E or drag corners after placement.

Click the pipe icon to enter connecting mode. Connect objects with pipes by selecting nodes and adjust them later if needed. Copy objects using Ctrl + C and paste with Ctrl + V. Use Shift to select multiple objects.

Manage objects via the Object Hierarchy and object’s Pop-Up Window, where you can rename, reposition, and focus the camera. Adjust widgets, notes, and labels using gizmos for precise placement.

  `,
  },

};

export const assetContent: AssetContent[] = [
  {
    id: "pi",
    title: "Pi",
    desc: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old."
  },
  {
    id: "data-center",
    title: "Data Center",
    desc: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old."
  },
  {
    id: "excel",
    title: "Excel",
    desc: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old."
  }
];

export const connectionProfile: ConnectionProfile[] = [
  {
    id: "p1",
    title: "OSI PI (P1)",
    status: "Connected"
  },
  {
    id: "p2",
    title: "OSI PI (P2)",
    status: "Connected"
  },
  {
    id: "p3",
    title: "Exel (P3)",
    status: "Imported"
  },
];

export const projectTypeEnergy = [
  {
    label: "Oil and Gas",
    value: "Oil and Gas"
  },
  {
    label: "Petrochemical",
    value: "Petrochemical"
  },
  {
    label: "Renewable Energy",
    value: "Renewable Energy"
  },
  {
    label: "Nuclear Energy",
    value: "Nuclear Energy"
  },
  {
    label: "Coal Industry",
    value: "Coal Industry"
  },
  {
    label: "Electric Power Generation and Utilities",
    value: "Electric Power Generation and Utilities"
  },
  {
    label: "Bioenergy",
    value: "Bioenergy"
  },
  {
    label: "Hydrogen Energy",
    value: "Hydrogen Energy"
  },
  {
    label: "Energy Storage and Battery Technologies",
    value: "Energy Storage and Battery Technologies"
  },
  {
    label: "Carbon Capture and Storage (CCS)",
    value: "Carbon Capture and Storage (CCS)"
  },
  {
    label: "Cyber security",
    value: "Cyber security"
  }
];

export const projectTypeSmartCity = [
  {
    label: "Smart Infrastructure",
    value: "Smart Infrastructure"
  },
  {
    label: "Smart Transportation and Mobility",
    value: "Smart Transportation and Mobility"
  },
  {
    label: "Smart Energy and Utilities",
    value: "Smart Energy and Utilities"
  },
  {
    label: "Smart Water Management",
    value: "Smart Water Management"
  },
  {
    label: "Smart Waste Management",
    value: "Smart Waste Management"
  },
  {
    label: "Smart Buildings and Construction",
    value: "Smart Buildings and Construction"
  },
  {
    label: "Smart Healthcare",
    value: "Smart Healthcare"
  },
  {
    label: "Smart Education",
    value: "Smart Education"
  },
  {
    label: "Smart Governance (e-Government)",
    value: "Smart Governance (e-Government)"
  },
  {
    label: "Smart Public Safety and Security",
    value: "Smart Public Safety and Security"
  },
  {
    label: "Smart Environmental Monitoring",
    value: "Smart Environmental Monitoring"
  },
  {
    label: "Smart Lighting Systems",
    value: "Smart Lighting Systems"
  },
  {
    label: "Smart Parking Solutions",
    value: "Smart Parking Solutions"
  },
  {
    label: "Smart Retail and Commerce",
    value: "Smart Retail and Commerce"
  },
  {
    label: "Smart Tourism",
    value: "Smart Tourism"
  },
  {
    label: "Smart Agriculture and Urban Farming",
    value: "Smart Agriculture and Urban Farming"
  },
  {
    label: "Smart Telecommunications and Connectivity (5G, IoT)",
    value: "Smart Telecommunications and Connectivity (5G, IoT)"
  },
  {
    label: "Smart Finance and Digital Payments",
    value: "Smart Finance and Digital Payments"
  },
  {
    label: "Smart Logistics and Supply Chain",
    value: "Smart Logistics and Supply Chain"
  },
  {
    label: "Smart Community and Citizen Engagement Platforms",
    value: "Smart Community and Citizen Engagement Platforms"
  }
];

export const projectTypeCyberSecurity = [
  {
    label: "Network Security",
    value: "Network Security"
  },
  {
    label: "Information Security (InfoSec)",
    value: "Information Security (InfoSec)"
  },
  {
    label: "Cloud Security",
    value: "Cloud Security"
  },
  {
    label: "Application Security",
    value: "Application Security"
  },
  {
    label: "Endpoint Security",
    value: "Endpoint Security"
  },
  {
    label: "Identity and Access Management (IAM)",
    value: "Identity and Access Management (IAM)"
  },
  {
    label: "Threat Intelligence and Analysis",
    value: "Threat Intelligence and Analysis"
  },
  {
    label: "Security Operations Center (SOC) Services",
    value: "Security Operations Center (SOC) Services"
  },
  {
    label: "Incident Response and Forensics",
    value: "Incident Response and Forensics"
  },
  {
    label: "Penetration Testing and Ethical Hacking",
    value: "Penetration Testing and Ethical Hacking"
  },
  {
    label: "Governance, Risk, and Compliance (GRC)",
    value: "Governance, Risk, and Compliance (GRC)"
  },
  {
    label: "Data Loss Prevention (DLP)",
    value: "Data Loss Prevention (DLP)"
  },
  {
    label: "Security Information and Event Management (SIEM)",
    value: "Security Information and Event Management (SIEM)"
  },
  {
    label: "Encryption and Cryptography",
    value: "Encryption and Cryptography"
  },
  {
    label: "Firewall and Perimeter Security",
    value: "Firewall and Perimeter Security"
  },
  {
    label: "Mobile Security",
    value: "Mobile Security"
  },
  {
    label: "Internet of Things (IoT) Security",
    value: "Internet of Things (IoT) Security"
  },
  {
    label: "Zero Trust Security",
    value: "Zero Trust Security"
  },
  {
    label: "Managed Security Services (MSSP)",
    value: "Managed Security Services (MSSP)"
  },
  {
    label: "Anti-Virus and Malware Protection",
    value: "Anti-Virus and Malware Protection"
  },
  {
    label: "Phishing and Email Security",
    value: "Phishing and Email Security"
  },
  {
    label: "Blockchain and Cryptocurrency Security",
    value: "Blockchain and Cryptocurrency Security"
  },
  {
    label: "Privacy and Data Protection",
    value: "Privacy and Data Protection"
  },
  {
    label: "Artificial Intelligence (AI) and Machine Learning (ML) Security",
    value: "Artificial Intelligence (AI) and Machine Learning (ML) Security"
  },
  {
    label: "Supply Chain Security",
    value: "Supply Chain Security"
  }
];

